import axios from 'axios'
import { CATALOGO_ENDPOINT } from 'common/endpoints'

export async function downloadStockTemplate() {
    const response = await axios(`${CATALOGO_ENDPOINT}/generateExcelTemplate`, {
        method: 'GET',
        responseType: 'blob',
        timeout: 20000, // 20 segundos
      })
    if (response.status === 200){
        return response.data
    }      
}